import { render, staticRenderFns } from "./AddNewService.vue?vue&type=template&id=e0d796c6&"
import script from "./AddNewService.vue?vue&type=script&lang=js&"
export * from "./AddNewService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports